// eslint-disable-next-line import/no-duplicates
import { format, formatDistance, formatRelative, isDate } from 'date-fns';
// eslint-disable-next-line import/no-duplicates
import { enUS, fr } from 'date-fns/locale';

const locales = { enUS, fr };

export enum DayPeriod {
  Morning = 'morning',
  Afternoon = 'afternoon',
  Evening = 'evening',
  Night = 'night',
}

const getLocale = (lng?: string) => {
  if (lng && lng in locales) {
    return locales[lng as keyof typeof locales];
  }
  return enUS;
};

export const formatShortDate = (date: Date, lng?: string) => {
  const locale = getLocale(lng);
  return format(date, 'P', { locale });
};

export const formatLongDate = (
  date: Date,
  lng?: string,
  options?: { hideWeekday?: boolean; hideYear?: boolean },
) => {
  const locale = getLocale(lng);
  const { hideWeekday = false, hideYear = false } = options || {};
  return format(date, `${hideWeekday ? '' : 'EEEE, '}MMMM d${hideYear ? '' : ', yyyy'}`, {
    locale,
  });
};

export const formatRelativeDate = (date: Date, lng?: string) => {
  const locale = getLocale(lng);
  return formatRelative(date, new Date(), { locale });
};

export const formatTime = (date: Date, lng?: string) => {
  const locale = getLocale(lng);
  return format(date, 'p', { locale });
};

export const formatTimeAgo = (date: Date, lng?: string) => {
  const locale = getLocale(lng);
  return formatDistance(date, new Date(), {
    locale,
    includeSeconds: true,
  });
};

export const getDayPeriod = (date: Date): string => {
  const hour = date.getHours();

  if (hour >= 5 && hour < 12) {
    return DayPeriod.Morning;
  }

  if (hour >= 12 && hour < 17) {
    return DayPeriod.Afternoon;
  }

  if (hour >= 17 && hour < 21) {
    return DayPeriod.Evening;
  }

  return DayPeriod.Night;
};

export { isDate };
